module.exports = __webpack_public_path__ + "static/media/gotmyer_eng.7dc62be5.mp4";